/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Contact_TitleInputs */

const en_seo_contact_title = /** @type {(inputs: Seo_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact for trainers`)
};

const pl_seo_contact_title = /** @type {(inputs: Seo_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt dla trenerów`)
};

/**
* | output |
* | --- |
* | "Contact for trainers" |
*
* @param {Seo_Contact_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_contact_title = /** @type {((inputs?: Seo_Contact_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Contact_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_contact_title(inputs)
	return en_seo_contact_title(inputs)
});